import React from 'react'
import { Link } from 'react-router-dom';
import Cart from '../Cart';

import Container from '@material-ui/core/Container';

import Typography from '../../Typography';
import SpotlioIcon from '../../Icon';
import MobileTabs from '../HeaderTabs/mobile';
import OldCurrencySelector from '../../OldCurencySelector';
import LanguageSelector from "../../LanguageSelector";
import Seasonality from "../../Seasonality";

import IntlMessage from '../../../LocaleEngine';

import { getCookie } from '../../../utils/CookiesRetriever';
import { getLoged, setCustomPhone, getCustomPhone } from "../../../utils/SettingsRetriever";
import QueryStringRetriever from '../../../utils/QueryStringRetriever';

import TATO from './TATO';

import './index.scss';

class Topbar extends React.Component{
    constructor(props){
        super(props);

        const QS = QueryStringRetriever;
        const configuration = this.props.configuration;

        // control of no local storage configuration
        // usually when local storage is cleaned during a session
        // if(!configuration){
        //     window.location.reload();
        // }

        let menuIcon = 'spotlio-menu';
        let shoppingCartIcon = 'spotlio-shopping-cart';

        if (configuration.hasOwnProperty('assets') && configuration.assets.hasOwnProperty('mobile')) {
            if(! !configuration.assets.mobile.menu_icon) menuIcon = configuration.assets.mobile.menu_icon;
        
            if(! !configuration.assets.mobile.cart_icon) shoppingCartIcon = configuration.assets.mobile.cart_icon;
        }
    
        let showLanguage = false;
        let showCurrency = false;
        let showProfile = false;
        let phone = false;
        let headMode = "default";
        let contacts = false;

        if (configuration.hasOwnProperty('head')) {
            if(! !configuration.head.multilanguage) showLanguage = configuration.head.multilanguage;
            if(! !configuration.head.multicurrency) showCurrency = configuration.head.multicurrency;
            if(! !configuration.head.profile) showProfile = configuration.head.profile;
            if(! !configuration.head.phone) phone = configuration.head.phone;
            if(! !configuration.head.mode) headMode = configuration.head.mode;
            if(! !configuration.head.contacts) contacts = configuration.head.contacts;
        }

        if (getCustomPhone()) {
            phone = getCustomPhone();
        }
        if (QS() && QS().NCK){
            let nck = QS().NCK.toString();
            let oldPhone = phone.phone.split("-").join("");
            let matches =  nck.match(/^(\+\d)?(\d{3})(\d{3})(\d{4})$/);
            
            if (matches && matches.length >= 4){
                phone.phone = `${matches[2]}-${matches[3]}-${matches[4]}`;
                phone.tel = phone.tel.replace(oldPhone, nck);
                setCustomPhone(phone)
            }
            
        }

        this.state = {
            menu: false,
            b2bCookie: JSON.parse(getCookie('b2b')),
            config: {
                menuIcon: menuIcon,
                shoppingCartIcon: shoppingCartIcon,
                showLanguage: showLanguage,
                showCurrency: showCurrency,
                showProfile: showProfile,
                phone: phone,
                contacts,
                headMode: headMode
            }
        }
    }

    toggleMenu = (value) => {
        if (window && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
            window.ReactNativeWebView.postMessage('Menu ' + (value ? 'abierto' : 'cerrado'));
        }

        this.setState({...this.state, menu: value});
    }

    renderTopbarLogo = () => {
        let logoStyles = {}
        if (this.props.configuration.head && this.props.configuration.head.logo && this.props.configuration.head.logo){
            logoStyles = {
                ...this.props.configuration.head.logo
            }
        }

        let customLogo = 'https://ik.imagekit.io/spotlio/dummy-px_nVIPQQD2f.png';
        if(this.props.configuration && this.props.configuration.assets && this.props.configuration.assets.logo) {
            customLogo = this.props.configuration.assets.logo;
        }

        const logo = (<img style={logoStyles} className={(this.props.configuration.head.logo ? "bigLogo" : "")} alt={this.props.configuration.head.title} src={customLogo} />);
        let logoMobile = false;
        if (this.props.configuration.assets && this.props.configuration.assets.mobile && this.props.configuration.assets.mobile.logo){
            logoMobile = <img className="mobileLogo" alt={this.props.configuration.head.title} src={this.props.configuration.assets.mobile.logo} />
        }
        if (this.props.configuration.head.site_url === '#' || !this.props.configuration.head.site_url) {
            return (
                <div className="logoWrapper">
                    { logo }
                    { logoMobile }
                </div>
            );
        } else {
            return (
                <a className="logoWrapper" rel="noopener noreferrer" target="_blank" href={this.props.configuration.head.site_url} title={this.props.configuration.head.title}>
                    { logo }
                    { logoMobile }
                </a>
            )
        }
    }

     renderCartBullet = () => {
        if (this.state.b2bCookie){
            return null;
        }

        return (
            <>
            {this.props.configuration.head.topbarConfiguration && this.props.configuration.head.topbarConfiguration.cartOnTabs ?
                null:
                <Cart isOnTab={false} cart={this.props.cart} onTrigger={this.props.onTrigger} configuration={this.props.configuration}/>    
            }
            </>
        
        )
    }
 
    renderOptions = () => {
        if (this.state.b2bCookie) {
            return (
                <TATO phone={this.state.config.phone} cartLength={this.props.cartLength} onCartTrigger={this.props.onTrigger} b2bCookie={this.state.b2bCookie} />
            )
        }
        
        return (
        <React.Fragment>
            <div className="message">
                {
                    this.state.config.phone && !this.state.config.contacts?
                        Array.isArray(this.state.config.phone) ?
                            this.state.config.phone.map((contact, index) => {
                                return (
                                    <div key={index}>
                                        {
                                            contact.label
                                            ? <React.Fragment>
                                                <IntlMessage id={contact.label || "skin.global.header.contact"} />: 
                                            </React.Fragment>
                                            : null 
                                        } 
                                        <strong>
                                            {
                                                contact.tel 
                                                ? <a href={"tel:" + contact.tel}> {contact.value}</a> 
                                                : contact.value 
                                            }
                                        </strong>
                                    </div>
                                )
                            })
                            :
                            <div>
                                <IntlMessage 
                                    id={ this.state.config.phone.label ? this.state.config.phone.label : "skin.global.header.contact"}
                                /> <strong><a href={"tel:" + this.state.config.phone.tel}>{this.state.config.phone.phone}</a></strong>
                            </div>
                        : ''
                }
            </div>
            {
                this.state.config.contacts && this.state.config.contacts.list ?
                <div className={`message ${this.state.config.contacts.display}`}>
                    {
                        this.state.config.contacts.list.map((contact, index) => {
                            return (
                                <React.Fragment>
                                    <div key={`contact_${index}`}>
                                        {contact.label ? <IntlMessage id={contact.label + ": "} /> : null}
                                        <strong>
                                            {
                                                contact.type === "phone" ?
                                                <a href={"tel:" + contact.link}> {contact.value}</a> 
                                                : 
                                                <a target="_blank" rel="noopener noreferrer" href={contact.link}> {contact.value}</a> 
                                            }
                                        </strong>
                                    </div>
                                    {
                                        this.state.config.contacts.display === "inline" && index + 1 !== this.state.config.contacts.list.length ?
                                        <div> | </div>
                                        : null
                                    }
                                </React.Fragment>
                                
                            )
                        })
                    }
                </div>
                : null
            }
            <div className="links">
                <ul>
                    {
                        this.props.configuration && this.props.configuration.seasonality && this.props.configuration.seasonality.enabled && this.props.configuration.seasonality.toggler
                        ? <li>
                            <Seasonality seasonality={this.props.configuration.seasonality} />
                        </li> 
                        : null
                    }
                    {
                        this.state.config.showCurrency && this.state.config.showCurrency.enabled !== false
                        ? <li>
                            <OldCurrencySelector configuration={this.props.configuration} mode="b2c" />
                        </li> 
                        : ''
                    }
                    {   this.state.config.showLanguage
                        ?   <li>
                                <LanguageSelector />
                            </li>  
                        : null
                    }
                    {   this.state.config.showProfile && this.state.config.showProfile.enabled !== false
                        ? <li>
                            <Link to={this.props.configuration.urlPrefix + '/account'}>
                                <IntlMessage id={this.state.config.showProfile.label || "header.info.my_account"} />
                            </Link>
                        </li> 
                        : ''
                    }
                </ul>
            </div>
        </React.Fragment>
        )
    }

    renderBoxedHeader = () => {
        return (
            <Container maxWidth="lg" className="boxedTopbarWrapper">
                <header className="container" >
                    <div className="content">
                        <div className="logo">
                            { this.renderTopbarLogo() }
                        </div>
                        <ul className="menuItems">
                            {
                                this.props.configuration.head && this.props.configuration.head.links && this.props.configuration.head.links.map((element, index) => {
                                    return (
                                        <li key={index} className="menuItem">
                                            <a target="_blank" rel="noopener noreferrer" href={element.href}>
                                                {element.name}
                                            </a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className="options">
                            { this.renderOptions() }
                        </div>
                        { this.renderCartBullet() }
                    </div>
                </header>
            </Container>
        );
    }

    getTopbarBackground = () => {
        if (window.innerWidth > 991 && this.props.configuration.head && this.props.configuration.head.topbarConfiguration && this.props.configuration.head.topbarConfiguration.backgroundImage){
            return `url(${this.props.configuration.head.topbarConfiguration.backgroundImage})`
        }
        return "";
    }
    
    getHeight = () => {
        if (window.innerWidth > 991 && this.props.configuration.head && this.props.configuration.head.topbarConfiguration && this.props.configuration.head.topbarConfiguration.height){
            return this.props.configuration.head.topbarConfiguration.height
        }
        return "";
    }

    getTopbarBackgroundPosition = () => {
        if (window.innerWidth > 991 && this.props.configuration.head && this.props.configuration.head.topbarConfiguration && this.props.configuration.head.topbarConfiguration.backgroundPosition){
            return this.props.configuration.head.topbarConfiguration.backgroundPosition
        }
        return "";
    }

    putOverlay = () => {
        if (window.innerWidth > 991 && this.props.configuration.head && this.props.configuration.head.topbarConfiguration && this.props.configuration.head.topbarConfiguration.overlay){
            return this.props.configuration.head.topbarConfiguration.overlay
        }
        return "";
    }

    render(){
        return (
        <React.Fragment>
            { this.state.config.headMode === "boxed" && this.renderBoxedHeader() }
            <header 
                style={
                    { 
                        backgroundImage: this.getTopbarBackground(),
                        height: this.getHeight(),
                        backgroundPosition:  this.getTopbarBackgroundPosition()
                    }
                } 
                className={"topbarWrapper " + this.state.config.headMode}
            >
                {this.putOverlay() && <div className="overlay" style={{ background: this.props.configuration.head.topbarConfiguration.overlay }} />}
                <MobileTabs toggleMenu={this.toggleMenu.bind(this)} menu={this.state.menu}/>
                <Container className="container" maxWidth="lg">
                    {/* <div className="mobileBackButton" /> */}
                    <div onClick={()=>this.toggleMenu(true)} className="menu">
                        <SpotlioIcon icon={"spotlio-menu"} />
                    </div>
                    <div className="logo">
                        { this.renderTopbarLogo() }
                    </div>
                    <div className="cart">
                        <span className="fa-stack has-badge" data-count={this.props.cart.badge}>
                            <Link to={this.props.configuration.urlPrefix + '/shopping-cart/review'} className="shoppingcart">
                                <div className="cartIcon">
                                    <SpotlioIcon icon="sp2-shopping-cart" />
                                    <div className="cartCounter">
                                        <Typography className="h200">
                                            {this.props.cart.badge}
                                        </Typography>
                                    </div>
                                </div>
                            </Link>
                        </span>
                    </div>
                    <div className="options">
                        { this.renderOptions() }
                        {
                            this.props.configuration.head && this.props.configuration.head.links &&
                            <div className="menuItems">
                                {
                                    this.props.configuration.head.links.map((element, index) => {
                                        return (
                                            <div key={index} className="menuItem">
                                                <a target="_blank" rel="noopener noreferrer" href={element.href}>
                                                    {element.name}
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                    { this.renderCartBullet() }
                    <div className="menuCartMobile">
                        {
                            this.props.configuration && this.props.configuration.head && this.props.configuration.head.hideMenuMobile
                            ? null
                            : <div onClick={()=>this.toggleMenu(true)} className="menu">
                                <SpotlioIcon icon={"spotlio-menu"} />
                              </div>
                        }
                        <div className="cart">
                            <span className="fa-stack has-badge" data-count={this.props.cart.badge}>
                                <Link to={this.props.configuration.urlPrefix + '/shopping-cart/review'} className="shoppingcart">
                                    <div className="cartIcon">
                                        <SpotlioIcon icon="sp2-shopping-cart" />
                                        <div className="cartCounter">
                                            <Typography className="h200">
                                                {this.props.cart.badge}
                                            </Typography>
                                        </div>
                                    </div>
                                </Link>
                            </span>
                        </div>
                        { this.renderCartBullet() }
                        { 
                            getLoged() &&
                            <div className="loged">
                                <SpotlioIcon icon="user-logged" />
                            </div>
                        }
                        {
                            this.state.config.phone && 
                            <div className="callCenter">
                                <a href={"tel:" + this.state.config.phone.tel}><SpotlioIcon icon={"feather-phone"} /></a>
                            </div>
                        }
                    </div>
                </Container>
            </header>
        </React.Fragment>
        )
    }
}

export default Topbar;